if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      // console.log(MutationList)
      for (let item of MutationList) {
        if (item.target.id === "AjaxCartForm") {
          BSS_B2B.observer.cartSubject.listenCartCheckout();
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);
  setTimeout(() => {
    const variantInputs = document.querySelectorAll(
      '[bss-b2b-product-form="main"] .product-variant__container input'
    );
    if (variantInputs.length) {
      variantInputs.forEach((item) => {
        item.addEventListener("click", (e) => {
          const productForm = document.querySelector(
            '[bss-b2b-product-form="main"]'
          );
          BSS_B2B.observer.productSubject.notifyObserver(
            "VariantChange",
            "VariantSelectChange",
            { event: e, productForm }
          );
        });
      });
    }
  }, 2000);
}

/* ============================================================
   Popis produktu: panel otevřený automaticky + sbalený náhled
   (1. odstavec), tlačítko „více/méně" na spodní čáře rámečku,
   plynulé rozbalení (roll). Kritické CSS se vkládá zde v JS,
   aby se prosadilo i při staré verzi bss-custom.css v cache.
   ============================================================ */
(function () {
  function vgInjectCss() {
    if (document.getElementById("vg-desc-css")) return;
    var css =
      ".card-widget--is-accordion-item{position:relative;}" +
      ".vg-desc-more{max-height:0;overflow:hidden;transition:max-height 1.8s cubic-bezier(.4,0,.2,1);}" +
      ".vg-desc-clamp{display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical;overflow:hidden;}" +
      ".vg-desc-toggle{position:absolute !important;left:50% !important;bottom:0 !important;transform:translate(-50%,50%) !important;margin:0 !important;padding:0 !important;width:auto !important;display:block !important;background:none !important;border:0 !important;color:var(--color-text-main,#1d1d1d);font-weight:700;font-size:inherit;line-height:1;cursor:pointer;z-index:3;}" +
      ".vg-desc-toggle::before,.vg-desc-toggle::after{content:none !important;display:none !important;background:none !important;}" +
      ".vg-desc-toggle__txt{display:inline-flex !important;align-items:center;gap:6px;white-space:nowrap;background:var(--color-background-cards,#fff);padding:0 14px;}" +
      ".vg-desc-toggle__txt::after{content:'\\25BE';font-size:.8em;}" +
      ".vg-desc-toggle.is-open .vg-desc-toggle__txt::after{content:'\\25B4';}" +
      ".card-widget--is-accordion-item:not(:has(.toggle.opened)) .vg-desc-toggle{display:none !important;}";
    var s = document.createElement("style");
    s.id = "vg-desc-css";
    s.textContent = css;
    document.head.appendChild(s);
  }

  function vgFindPopisWidgets() {
    var ws = [];
    document
      .querySelectorAll(".card-widget--is-accordion-item")
      .forEach(function (w) {
        var h = w.querySelector(".card-widget__header-text__title");
        if (h && /popis/i.test(h.textContent)) ws.push(w);
      });
    return ws;
  }

  function vgOpenWidget(w) {
    var tab = w.querySelector("toggle-tab") || w.querySelector(".toggle");
    var title = w.querySelector(".toggle__title");
    if (tab && title && !tab.classList.contains("opened")) {
      title.click();
    }
  }

  /* Vlastní plynulý scroll — native smooth je na této šabloně blokovaný,
     a galerie fotky je position:sticky (scrollIntoView na ni nefunguje).
     Pozici si vynucujeme v každém snímku, takže ji nic nepřebije. */
  function vgSmoothScroll(toY, dur) {
    var startY = window.pageYOffset;
    var dist = toY - startY;
    if (Math.abs(dist) < 2) return;
    var root = document.documentElement;
    root.style.overflowAnchor = "none";
    var t0 = null;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = 0.5 - Math.cos(p * Math.PI) / 2;
      window.scrollTo(0, Math.round(startY + dist * e));
      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        setTimeout(function () {
          root.style.overflowAnchor = "";
        }, 100);
      }
    }
    requestAnimationFrame(step);
  }

  function vgApply(el) {
    if (el.dataset.vgReadmore) return;

    var blocks = Array.prototype.filter.call(el.children, function (n) {
      return n.nodeType === 1 && n.textContent.trim() !== "" && !n.classList.contains("vg-desc-toggle");
    });

    var mode = null;
    var wrap = null;
    if (blocks.length > 1) {
      mode = "blocks";
      wrap = document.createElement("div");
      wrap.className = "vg-desc-more";
      for (var i = 1; i < blocks.length; i++) {
        wrap.appendChild(blocks[i]);
      }
      el.appendChild(wrap);
    } else if (el.textContent.trim().length > 300) {
      mode = "clamp";
      el.classList.add("vg-desc-clamp");
    }
    if (!mode) return;

    el.dataset.vgReadmore = "1";

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "vg-desc-toggle";
    btn.innerHTML = '<span class="vg-desc-toggle__txt">více</span>';
    el.insertAdjacentElement("afterend", btn);

    btn.addEventListener("click", function () {
      var open = !btn.classList.contains("is-open");
      btn.classList.toggle("is-open", open);
      btn.querySelector(".vg-desc-toggle__txt").firstChild.nodeValue = open
        ? "méně"
        : "více";
      if (mode === "blocks") {
        if (open) {
          wrap.style.maxHeight = wrap.scrollHeight + "px";
        } else {
          wrap.style.maxHeight = wrap.scrollHeight + "px";
          void wrap.offsetHeight; // vynutit reflow, aby se spustil přechod
          wrap.style.maxHeight = "0";
          // po dokončení zabalení plynule odscrollovat na fotku produktu
          setTimeout(function () {
            var sec =
              document.querySelector("product-page") ||
              document.querySelector('[class*="mount-product"]') ||
              document.querySelector(".product-gallery");
            if (sec) {
              var top = sec.getBoundingClientRect().top + window.pageYOffset - 20;
              vgSmoothScroll(Math.max(0, top), 550);
            }
          }, 1850);
        }
      } else {
        el.classList.toggle("vg-desc-clamp", !open);
      }
    });
  }

  function vgInit() {
    vgInjectCss();
    vgFindPopisWidgets().forEach(function (w) {
      var c =
        w.querySelector(".card-widget__content.rte") ||
        w.querySelector(".card-widget__content");
      if (c) vgApply(c);
      vgOpenWidget(w);
    });
    document.querySelectorAll(".product__description.rte").forEach(vgApply);
  }

  if (document.readyState !== "loading") {
    vgInit();
  } else {
    document.addEventListener("DOMContentLoaded", vgInit);
  }
  setTimeout(vgInit, 700);
  setTimeout(vgInit, 1600);
})();
